import { enumAlertType } from '../enums';

export class Alert {
  public type: enumAlertType;
  public title: string;
  public message: string;
  public alertId: string;
  public keepAfterRouteChange: boolean;
  public isCloseAfterTimeout?: boolean = true;

  constructor(init?: Partial<Alert>) {
    Object.assign(this, init);
  }
}
